export const placeHolder = {
    page: 'stitching',
    subtitle: '多张图片快速拼接，为您生成最优布局',
    image: 'https://feed-image.baidu.com/0/pic/533030698_1549823988_-56109884.png'
};
export const maxUploadNum = 9;
export const defaultFormData = {
    stitchLayout: {
        type: 2,
        value: {
            chooseValue: '2-1'
        }
    },
    stitchTargetCount: { // 批图模板变化时、以及拼图上传变化时，更新stitchTargetCount
        targetCount: 1, // 拼图数量
        uploadList: []
    },
    // 尺寸
    sizeControl: {
        // 选择：choose
        // 自定义：'custom'
        type: 'choose',
        value: {
            ratio: '1:1',
            dimension: '600*600',
            customWidth: 600,
            customHeight: 600,
            customTips: ''
        }
    },
    stitchSpace: {
        value: '0'
    }
};
export const sizeOptions = [
    {
       value: '16:9',
       label: '16:9',
       children: [
           {
               value: '1140*640',
               label: '1140*640'
           }, {
               value: '1280*720',
               label: '1280*720'
           }, {
               value: '1600*900',
               label: '1600*900'
           }, {
               value: '1920*1080',
               label: '1920*1080'
           }
       ]
   }, {
       value: '9:16',
       label: '9:16',
       children: [
           {
               value: '1080*1920',
               label: '1080*1920'
           }, {
               value: '1242*2208',
               label: '1242*2208'
           }, {
               value: '720*1280',
               label: '720*1280'
           }
       ]
   }, {
       value: '4:3',
       label: '4:3',
       children: [
           {
               value: '800*600',
               label: '800*600'
           }
        //    , {
        //        value: '120*90',
        //        label: '120*90'
        //    }
       ]
   }, {
       value: '3:4',
       label: '3:4',
       children: [
           {
               value: '600*800',
               label: '600*800'
           }
       ]
   }, {
       value: '1:1',
       label: '1:1',
       children: [
           {
               value: '600*600',
               label: '600*600'
           }
        //    , {
        //        value: '240*240',
        //        label: '240*240'
        //    }, {
        //        value: '220*220',
        //        label: '220*220'
        //    }, {
        //        value: '360*360',
        //        label: '360*360'
        //    }, {
        //        value: '480*480',
        //        label: '480*480'
        //    }, {
        //        value: '300*300',
        //        label: '300*300'
        //    }
       ]
   }, {
       value: '3:1',
       label: '3:1',
       children: [
           {
               value: '1200*400',
               label: '1200*400'
           }, {
               value: '900*300',
               label: '900*300'
           }
       ]
   }
];